import React, { useEffect, useRef, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useLazyQuery, useMutation } from '@apollo/client'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import TextField from '../../../../sharedComponent/TextField/TextField'
import EmailTpvReport from "../../../../sharedComponent/emailTpvReport/emailTpvReport"
import {
  UPDATE_CUSTOMER,
  GET_TPV_AUDIT_LIST,
  GET_CLIENT_ALLOWED_COMPONENTS,
} from '../../../../../utils/GraphQLAPI'
import { State } from 'country-state-city'
import Dropdown from '../../../../sharedComponent/Dropdown/Dropdown'
import Viewer from '../../../../sharedComponent/viewer'
import GMap from '../../../../sharedComponent/Gmap'
import { GLOBAL_CONSTANTS } from '../../../../../utils/GlobalConstants'
import CustomerAudit from './CustomerAudit/CustomerAudit'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import TooltipCommon from '../../../../sharedComponent/CustomTooltip/TooltipCommon'
interface CustomerInfoProps {
  data: any
  handleSubmitted: any
  ediStatus: string
  featureFlags: any
  agentData?: any
  tpvId?: string
  showAudit: boolean
  showMapAndDistance: boolean
}

type defaultCustomerInfoType = {
  firstName?: string | null
  lastName?: string | null
  uan?: string | null
  guan?: string | null
  businessName?: string | null
  phoneNumber?: string | null
  emailId?: string | null
  product?: string | null // Note: businessName is API Key
  gproduct: string | null
  serviceAddressLine1?: string | null
  serviceAddressLine2?: string | null
  serviceCountry?: string | null
  serviceState?: string | null
  serviceCity?: string | null
  serviceZipCode?: string | null
  serviceUnitType?: string | null
  serviceUnitTypeId?: string | null
  serviceUnitNumber?: string | null
  billingAddressLine1?: string | null
  billingAddressLine2?: string | null
  billingCountry?: string | null
  billingState?: string | null
  billingCity?: string | null
  billingZipCode?: string | null
  billingUnitType?: string | null
  billingUnitTypeId?: string | null
  billingUnitNumber?: string | null
  contractStartDate?: string | null
  gcontractStartDate?: string | null
  phoneType?: string | null
}
const defaultCustomerInfo: defaultCustomerInfoType = {
  firstName: '',
  lastName: '',
  uan: '',
  guan: '',
  contractStartDate: '',
  gcontractStartDate: '',
  businessName: '',
  phoneNumber: '',
  phoneType: '',
  gproduct: '',
  emailId: '',
  product: '', // Note: businessName is API Key
  serviceAddressLine1: '',
  serviceAddressLine2: '',
  serviceCountry: '',
  serviceState: '',
  serviceCity: '',
  serviceZipCode: '',
  serviceUnitType: '',
  serviceUnitTypeId: null,
  serviceUnitNumber: '',
  billingAddressLine1: '',
  billingAddressLine2: '',
  billingCountry: 'US',
  billingState: '',
  billingCity: '',
  billingZipCode: '',
  billingUnitType: '',
  billingUnitTypeId: null,
  billingUnitNumber: '',
}
const specCharErr = 'Special characters are not allowed'
const addressPlaceholder = 'Enter Unit, Suite, Floor, Building, etc.'
const emailVallidation = 'Email ID is not Valid'
const basicValidationSchema = {
  firstName: Yup.string()
    .required('First Name is required')
    .trim()
    .matches(/^[0-9a-zA-Z \b-]+$/, specCharErr)
    .min(3, "First Name shouldn't be less than 3 characters")
    .max(40, "First Name shouldn't exceed 40 characters"),
  lastName: Yup.string()
    .matches(/^[0-9a-zA-Z \b-]+$/, specCharErr)
    .trim()
    .min(1, "Last Name shouldn't be less than 1 characters")
    .max(40, "Last Name shouldn't exceed 40 characters"),
  phoneNumber: Yup.string()
    .required('Phone number is required')
    .trim()
    .min(10, 'Phone Number is less than 10 digits')
    .max(10, "Phone Number shouldn't exceed 10 digits")
    .matches(
      /^(\+|1\s)?(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d+)\)?)[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?)+)(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i,
      'Invalid phone number'
    ),
  emailId: Yup.string()
    .trim()
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, emailVallidation)
    .min(10, "Email ID shouldn't be less than 10 characters")
    .max(40, "Email ID shouldn't exceed 40 characters"),
  serviceAddressLine1: Yup.string()
    .required('Service address is required')
    .trim()
    .min(3, "Service address shouldn't be less than 3 characters")
    .max(230, "Service address shouldn't exceed 230 characters"),
  serviceAddressLine2: Yup.string()
    .min(3, "Service address shouldn't be less than 3 characters")
    .max(230, "Service address shouldn't exceed 230 characters"),
  serviceState: Yup.string().required('Service state is required'),
  serviceCity: Yup.string()
    .required('Service city is required')
    .matches(/^[A-Za-z- ]+$/, 'Enter a valid service city name')
    .min(3, 'Service city should not be less than 3 characters')
    .max(40, "Service city shouldn't exceed 40 characters"),
  serviceZipCode: Yup.string()
    .required('Service zip code is required')
    .matches(/^(?!0{5})([0-9]{5}(?:-[0-9]{4})?|[A-Z][0-9][A-Z])$/, 'Enter a valid zip code'),
  billingAddressLine1: Yup.string()
    .required('Billing address is required')
    .trim()
    .min(3, "Billing address shouldn't be less than 3 characters")
    .max(230, "Billing address shouldn't exceed 230 characters"),
  billingAddressLine2: Yup.string()
    .min(3, "Billing address shouldn't be less than 3 characters")
    .max(230, "Billing address shouldn't exceed 230 characters"),
  billingState: Yup.string().required('Billing state is required'),
  billingCity: Yup.string()
    .required('Billing city is required')
    .matches(/^[A-Za-z- ]+$/, 'Enter a valid city name')
    .min(3, "Billing city shouldn't be less than 3 characters")
    .max(40, "Billing city shouldn't exceed 40 characters"),
  billingZipCode: Yup.string()
    .required('Billing zip code is required')
    .matches(/^(?!0{5})([0-9]{5}(?:-[0-9]{4})?|[A-Z][0-9][A-Z])$/, 'Enter a valid zip code'),
}
const CustomerInfo = ({
  data,
  handleSubmitted,
  featureFlags,
  ediStatus,
  agentData,
  tpvId,
  showAudit,
  showMapAndDistance,
}: CustomerInfoProps) => {
  const MySwal = withReactContent(Swal)
  const [btnShow, setBtnShow] = useState<boolean>(false)
  const [dataFeed, setDataFeed] = useState<boolean>(false)
  const [sameAddress, setSameAddress] = useState<boolean>(false)
  const getAllStates = State.getStatesOfCountry('US')
  const [stateOptionList, setStateOptionList] = useState<any>([])
  const [validationSchema, setValidationSchema] = useState<any>(() => basicValidationSchema)
  const [isSolarProduct, setIsSolarProduct] = useState<any>(false)
  const [getClientAllowedComponents] = useLazyQuery(GET_CLIENT_ALLOWED_COMPONENTS, {
    onCompleted: (data) => {
      setIsSolarProduct(data?.getClientAllowedComponents.includes('solarProductSetup'))
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  useEffect(() => {
    getClientAllowedComponents()
  }, [])// eslint-disable-line react-hooks/exhaustive-deps

  const customerInfoDetails = [
    {
      fieldTitle: 'Business Name',
      fieldTitleMandatory: false,
      fieldName: 'businessName',
      placeHolder: 'Enter Business name',
      disabled: false,
    },
    {
      fieldTitle: 'First Name',
      fieldTitleMandatory: false,
      fieldName: 'firstName',
      placeHolder: 'Enter first name',
      maxLength: 50,
      disabled: false,
    },
    {
      fieldTitle: 'Last Name',
      fieldTitleMandatory: false,
      fieldName: 'lastName',
      placeHolder: 'Enter last name',
      maxLength: 50,
      disabled: false,
    },
    {
      fieldTitle: 'Phone Number',
      fieldTitleMandatory: false,
      fieldName: 'phoneNumber',
      placeHolder: 'Enter phone number',
      maxLength: 20,
      disabled: true,
    },

    {
      fieldTitle: 'Email ID',
      fieldTitleMandatory: false,
      fieldName: 'emailId',
      placeHolder: 'Enter email id',
      maxLength: 50,
      disabled: true,
    },
    {
      fieldTitle: Boolean(data?.gproduct) ? 'Electric Product' : 'Product',
      fieldTitleMandatory: false,
      fieldName: 'product',
      placeHolder: 'Enter product',
      maxLength: 50,
      disabled: true,
    },
  ]


  const serviceAddressDetails = [
    [
      {
        fieldTitle: 'Address Line 1',
        filedTitleMandatory: false,
        fieldName: 'serviceAddressLine1',
        placeHolder: addressPlaceholder,
        maxLength: '250',
        disabled: false,
      },
    ],
    [
      {
        fieldTitle: 'Address Line 2',
        filedTitleMandatory: false,
        fieldName: 'serviceAddressLine2',
        placeHolder: addressPlaceholder,
        maxLength: '250',
        disabled: false,
      },
    ],
    [
      {
        fieldTitle: 'Country',
        filedTitleMandatory: false,
        fieldName: 'serviceCountry',
        placeHolder: 'Enter country',
        maxLength: '50',
        disabled: true,
      },
      {
        fieldTitle: 'State',
        filedTitleMandatory: false,
        fieldName: 'serviceState',
        placeHolder: '',
        maxLength: '100',
        disabled: false,
      },
      {
        fieldTitle: 'City',
        filedTitleMandatory: false,
        fieldName: 'serviceCity',
        placeHolder: 'Enter city',
        maxLength: '50',
        disabled: false,
      },
    ],
    [
      {
        fieldTitle: 'Zip Code',
        filedTitleMandatory: false,
        fieldName: 'serviceZipCode',
        placeHolder: 'Enter zip code',
        maxLength: '20',
        disabled: false,
      },
      // {
      //   fieldTitle: 'Unit Number',
      //   filedTitleMandatory: false,
      //   fieldName: 'serviceUnitNumber',
      //   placeHolder: 'Enter unit number',
      //   maxLength: '30',
      //   disabled: false
      // },
    ],
  ]

  useEffect(() => {
    if (data?.documentDelivery === 'EMAIL') {
      setValidationSchema({
        ...validationSchema,
        emailId: Yup.string()
          .trim()
          .email(emailVallidation)
          .matches(/^(?!.*@[^,]*,)/, emailVallidation)
          .min(10, "Email ID shouldn't be less than 10 characters")
          .max(40, "Email ID shouldn't exceed 40 characters"),
      })
    } else {
      setValidationSchema(basicValidationSchema)
    }
  }, [data?.documentDelivery]) // eslint-disable-line react-hooks/exhaustive-deps

  const billingAddressDetails = [
    [
      {
        fieldName: 'billingAddressLine1',
        fieldTitle: 'Address Line 1',
        filedTitleMandatory: false,
        placeHolder: addressPlaceholder,
        maxLength: '250',
        disabled: false,
      },
    ],
    [
      {
        fieldName: 'billingAddressLine2',
        fieldTitle: 'Address Line 2',
        filedTitleMandatory: false,
        placeHolder: addressPlaceholder,
        maxLength: '250',
        disabled: false,
      },
    ],
    [
      {
        fieldName: 'billingCountry',
        fieldTitle: 'Country',
        filedTitleMandatory: false,
        placeHolder: 'Enter country',
        maxLength: '50',
        disabled: true,
      },
      {
        fieldName: 'billingState',
        fieldTitle: 'State',
        filedTitleMandatory: false,
        placeHolder: '',
        maxLength: '100',
        disabled: false,
      },
      {
        fieldName: 'billingCity',
        fieldTitle: 'City',
        filedTitleMandatory: false,
        placeHolder: 'Enter city',
        maxLength: '50',
        disabled: false,
      },
    ],
    [
      {
        fieldName: 'billingZipCode',
        fieldTitle: 'Zip Code',
        filedTitleMandatory: false,
        placeHolder: 'Enter zip code',
        maxLength: '20',
        disabled: false,
      },

      // {
      //   fieldName: 'billingUnitNumber',
      //   fieldTitle: 'Unit Number',
      //   filedTitleMandatory: false,
      //   placeHolder: 'Enter unit number',
      //   maxLength: '30',
      //   disabled: false
      // },
    ],
  ]

  const customerInfoSchema = Yup.object().shape(validationSchema)
  const [getTPVAuditList, { data: auditData, loading: auditDataLoading }] = useLazyQuery(
    GET_TPV_AUDIT_LIST,
    {
      fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
      onCompleted: (data) => console.log(data),
    }
  )
  const [filterOptions, setFilterOptions] = useState(() => ({
    page: 1,
    perPage: 10,
    tpvId: tpvId,
    orderBy: 'DESC',
  }))
  const [updateCustomer] = useMutation(UPDATE_CUSTOMER, {
    fetchPolicy: 'network-only',
    onCompleted: (customerData: any) => {
      setBtnShow(false)
      if (customerData) {
        handleSubmitted()
        const options: any = {
          customClass: {
            popup: 'swal2-border-radius',
          },
          title: 'Customer details updated successfully',
          icon: 'success',
          confirmButtonColor: '#3E97FF',
        }
        MySwal.fire(options)
        setDataFeed(false)
      }
      if (tpvId && showAudit) {
        getTPVAuditList({
          variables: filterOptions,
        })
      }
    },
  })
  useEffect(() => {
    if (showAudit) {
      getTPVAuditList({
        variables: filterOptions,
      })
    }
  }, [filterOptions])// eslint-disable-line react-hooks/exhaustive-deps
  const formik = useFormik({
    initialValues: defaultCustomerInfo,
    validationSchema: customerInfoSchema,
    enableReinitialize: false,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      const updateCustomerInput = {
        id: data.id,
        firstName: values.firstName,
        lastName: values.lastName,
        emailId: values.emailId,
        businessName: values.businessName,
        serviceAddress1: values.serviceAddressLine1,
        serviceAddress2: values.serviceAddressLine2,
        serviceCountry: values.serviceCountry,
        serviceState: values.serviceState,
        serviceCity: values.serviceCity,
        serviceZipCode: values.serviceZipCode,
        serviceUnitTypeId: values.serviceUnitTypeId,
        serviceUnitNumber: values.serviceUnitNumber,
        billingAddress1: sameAddress ? values.serviceAddressLine1 : values.billingAddressLine1,
        billingAddress2: sameAddress ? values.serviceAddressLine2 : values.billingAddressLine2,
        billingCountry: sameAddress ? values.serviceCountry : values.billingCountry,
        billingState: sameAddress ? values.serviceState : values.billingState,
        billingCity: sameAddress ? values.serviceCity : values.billingCity,
        billingZipCode: sameAddress ? values.serviceZipCode : values.billingZipCode,
        billingUnitTypeId: sameAddress ? values.serviceUnitTypeId : values.billingUnitTypeId,
        billingUnitNumber: sameAddress ? values.serviceUnitNumber : values.billingUnitNumber,
      }
      updateCustomer({
        variables: {
          updateCustomerInput,
        },
      })
    },
  })
  const handleEdit = () => {
    setBtnShow(true)
  }
  const handleOnChange = (e: any, name: string) => {
    formik.setFieldValue(name, e.target.value)
  }

  const handleDataFeed = (
    objSameAddr: boolean,
    isCheckBoxClicked: boolean,
    isDataFeed: boolean
  ) => {
    let customerDetails: any
    if (!isDataFeed) {
      const electricUan = data?.customerEnrollments.filter(
        (uan: any) => uan.productType === 'Electric'
      )[0]
      const gasUan = data?.customerEnrollments.filter((uan: any) => uan.productType === 'Gas')[0]
      customerDetails = {
        firstName: data?.firstName,
        lastName: data?.lastName,
        businessName: data?.businessName,
        uan: isSolarProduct
          ? data?.customerEnrollments[0].utilityAccountNumber
          : electricUan?.utilityAccountNumber,
        guan: gasUan?.utilityAccountNumber,
        gmeterId: gasUan?.utilityMeterNumber,
        meterId: electricUan?.utilityMeterNumber,
        contractStartDate: isSolarProduct
          ? data?.customerEnrollments[0].contractStartDate
          : electricUan?.contractStartDate,
        gcontractStartDate: gasUan?.contractStartDate,
        phoneNumber: data?.primaryPhoneNumber,
        phoneType: data?.phoneType,
        emailId: data?.emailId,
        product: data?.product?.name,
        gproduct: data?.gproduct,
        serviceAddressLine1: data?.serviceAddress1,
        serviceAddressLine2: data?.serviceAddress2,
        serviceCountry: data?.serviceCountry,
        serviceState: data?.serviceState,
        serviceCity: data?.serviceCity,
        serviceZipCode: data?.serviceZipCode,
        serviceUnitType: data?.serviceUnitType?.name,
        serviceUnitTypeId: data?.serviceUnitType?.id,
        serviceUnitNumber: data?.serviceUnitNumber,
        billingAddressLine1: data?.billingAddress1,
        billingAddressLine2: data?.billingAddress2,
        billingCountry: data?.billingCountry,
        billingState: data?.billingState,
        billingCity: data?.billingCity,
        billingZipCode: data?.billingZipCode,
        billingUnitType: data?.billingUnitType?.name,
        billingUnitTypeId: data?.billingUnitType?.id,
        billingUnitNumber: data?.billingUnitNumber,
      }
    } else {
      customerDetails = {
        firstName: formik.getFieldMeta('firstName').value,
        lastName: formik.getFieldMeta('lastName').value,
        businessName: formik.getFieldMeta('businessName').value,
        uan: formik.getFieldMeta('uan').value,

        guan: formik.getFieldMeta('guan').value,

        phoneNumber: formik.getFieldMeta('phoneNumber').value,
        phoneType: formik.getFieldMeta('phoneType').value,
        emailId: formik.getFieldMeta('emailId').value,
        product: formik.getFieldMeta('product').value,
        serviceAddressLine1: formik.getFieldMeta('serviceAddressLine1').value,
        serviceAddressLine2: formik.getFieldMeta('serviceAddressLine2').value,
        serviceCountry: formik.getFieldMeta('serviceCountry').value,
        serviceState: formik.getFieldMeta('serviceState').value,
        serviceCity: formik.getFieldMeta('serviceCity').value,
        serviceZipCode: formik.getFieldMeta('serviceZipCode').value,

        billingAddressLine1: !objSameAddr
          ? isCheckBoxClicked && formik.getFieldMeta('serviceAddressLine1').value
          : '',
        billingAddressLine2: !objSameAddr
          ? isCheckBoxClicked && formik.getFieldMeta('serviceAddressLine2').value
          : '',
        billingCountry: !objSameAddr
          ? isCheckBoxClicked && formik.getFieldMeta('serviceCountry').value
          : 'US',
        billingState: !objSameAddr
          ? isCheckBoxClicked && formik.getFieldMeta('serviceState').value
          : '',
        billingCity: !objSameAddr
          ? isCheckBoxClicked && formik.getFieldMeta('serviceCity').value
          : '',
        billingZipCode: !objSameAddr
          ? isCheckBoxClicked && formik.getFieldMeta('serviceZipCode').value
          : '',
      }
    }
    formik.setValues({ ...customerDetails })
  }

  const handleCheckBox = (obj: any) => {
    if (sameAddress) {
      handleDataFeed(true, true, true)
    } else {
      handleDataFeed(false, true, true)
    }
    setSameAddress(!sameAddress)
  }
  useEffect(() => {
    if (stateOptionList.length === 0) {
      const stateOptions: any = []
      getAllStates.forEach((element: any) => {
        stateOptions.push({
          id: element.isoCode,
          value: element.name,
        })
      })
      setStateOptionList(stateOptions)
    }
    if (!dataFeed && data && stateOptionList.length > 0) {
      handleDataFeed(false, false, false)
      if (
        data.serviceAddress1.length > 0 &&
        data.serviceAddress1 === data.billingAddress1 &&
        data.serviceAddress2 === data.billingAddress2
      ) {
        setSameAddress(true)
      }
      setDataFeed(true)
    }
  }, [data, dataFeed, stateOptionList])// eslint-disable-line react-hooks/exhaustive-deps

  const handleSelectedItem = (e: any, name: any) => {
    if (e.value.length > 0) {
      formik.setFieldValue(name, e.label)
      formik.setFieldValue(`${name}Id`, e.value)
    } else {
      formik.setFieldValue(name, '')
      formik.setFieldValue(`${name}Id`, null)
    }
  }

  const handleDiscard = () => {
    formik.resetForm()
    handleDataFeed(false, false, false)
    if (
      data?.serviceAddress1?.length > 0 &&
      data?.serviceAddress1 === data?.billingAddress1 &&
      data?.serviceAddress2 === data?.billingAddress2
    ) {
      setSameAddress(true)
    } else {
      setSameAddress(false)
    }
    setBtnShow(false)
  }
  const rowRef = useRef() as React.MutableRefObject<HTMLDivElement>
  const fieldName = formik.getFieldMeta('colItem.fieldName').value
  return (
    <div>
      <div className='current p-4' data-kt-stepper-element='content'>
        {/* Modal Header Start */}
        <div className='row mb-5' style={{ minHeight: '45px' }}>
          {/* Title */}
          <div className='col-6'>
            <label className='d-flex align-items-center fs-4 fw-bold mb-4 lh-1'>
              <span className='fs-3 fw-bolder text-gray-900'>Customer Info</span>
              {data?.customerEnrollments[0]?.isCustomerFlaggedByQC && (
                <TooltipCommon
                  text={data?.customerEnrollments[0].qcReview}
                  coverClassName='d-inline'
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='16'
                    height='16'
                    fill='red'
                    className='bi bi-exclamation-octagon ms-2'
                    viewBox='0 0 16 16'
                  >
                    <path d='M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1z' />
                    <path d='M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z' />
                  </svg>
                </TooltipCommon>
              )}
            </label>
          </div>
          {/* Edit button */}
          <div className='col-6 d-flex justify-content-end'>
            <button
              type='button'
              disabled={ediStatus?.toUpperCase() === 'COMPLETED'}
              className={`btn btn-primary text-white btn-active-color-primary btn-md me-1 ${btnShow ? 'd-none' : null
                }`}
              onClick={() => handleEdit()}
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
            >
              Edit
            </button>
          </div>
        </div>
        <Row className='d-flex mt-5 no-gutters noPadding' style={{ marginBottom: '1.25rem' }}>
          <Col
            md={
              featureFlags?.getClientFeatureFlags?.isBillImagesRequired &&
                data?.billImageUrl.length > 0
                ? 6
                : 12
            }
          >
            <Row>
              {customerInfoDetails.map((colItem: any, index: number) => {
                return (
                  <Col
                    sm={4}
                    md={
                      featureFlags?.getClientFeatureFlags?.isBillImagesRequired &&
                        data?.billImageUrl.length > 0
                        ? 6
                        : 4
                    }
                    className='pb-5'
                    key={index}
                  >
                    <TextField
                      fieldTitle={colItem.fieldTitle}
                      filedTitleMandatory={colItem.filedTitleMandatory}
                      fieldName={colItem.fieldName}
                      placeHolder={colItem.placeHolder}
                      maxLength={colItem.maxLength}
                      fieldValue={formik.getFieldMeta(colItem.fieldName).value}
                      disabled={
                        colItem.fieldName === 'businessName'
                          ? !Boolean(formik.getFieldMeta(colItem.fieldName).value)
                            ? true
                            : !btnShow
                          : colItem.disabled
                            ? true
                            : !btnShow
                      }
                      handleOnChange={handleOnChange}
                      formik={formik}
                    />
                  </Col>
                )
              })}
              {Boolean(data?.gproduct) && (
                <Col sm={4} md={4} ref={rowRef}>
                  <TextField
                    fieldTitle={'Gas Product'}
                    filedTitleMandatory={false}
                    fieldName={'gproduct'}
                    placeHolder={'Enter Gas Product'}
                    fieldValue={formik.getFieldMeta('gproduct').value}
                    disabled={true}
                    handleOnChange={handleOnChange}
                    formik={formik}
                  />
                </Col>
              )}
              {Boolean(formik.getFieldMeta('uan').value) && (
                <Col sm={4} md={4} ref={rowRef}>
                  <TextField
                    fieldTitle={isSolarProduct ? 'UAN' : 'E_UAN'}
                    filedTitleMandatory={false}
                    fieldName={'uan'}
                    placeHolder={isSolarProduct ? 'Enter UAN' : 'Enter E_UAN'}
                    fieldValue={fieldName}
                    disabled={true}
                    handleOnChange={handleOnChange}
                    formik={formik}
                  />
                </Col>
              )}
              {Boolean(formik.getFieldMeta('meterId').value) && (
                <Col sm={4} md={4}>
                  <TextField
                    fieldTitle={'E_meterId'}
                    filedTitleMandatory={false}
                    fieldName={'meterId'}
                    placeHolder={'Enter E_UAN'}
                    fieldValue={fieldName}
                    disabled={true}
                    handleOnChange={handleOnChange}
                    formik={formik}
                  />
                </Col>
              )}
              {formik.getFieldMeta('contractStartDate').value && (
                <Col sm={4} md={4} ref={rowRef}>
                  <label htmlFor={'contractStartDate'} className='d-flex align-items-center mb-2'>
                    <span className='fs-6 fw-semibold lh-23px'>
                      {isSolarProduct ? `Contract Start Date` : `E_Contract Start Date`}
                    </span>
                  </label>
                  <DatePicker
                    className='form-control form-control-lg form-control-solid mb-2 '
                    id={'startDate'}
                    minDate={new Date()}
                    selected={
                      formik.values.contractStartDate
                        ? new Date(formik.values.contractStartDate)
                        : null
                    }
                    onChange={(val) => formik.setFieldValue('contractStartDate', val)}
                    dateFormat='MM-dd-yyyy'
                    autoComplete='off'
                    placeholderText='MM-DD-YYYY'
                    disabled={true}
                  />
                </Col>
              )}
              {Boolean(formik.getFieldMeta('guan').value) && (
                <Col sm={4} md={4}>
                  <TextField
                    fieldTitle={'G_UAN'}
                    filedTitleMandatory={false}
                    fieldName={'guan'}
                    placeHolder={'Enter G_UAN'}
                    fieldValue={fieldName}
                    disabled={true}
                    handleOnChange={handleOnChange}
                    formik={formik}
                  />
                </Col>
              )}

              {Boolean(formik.getFieldMeta('gmeterId').value) && (
                <Col sm={4} md={4}>
                  <TextField
                    fieldTitle={'G_meterId'}
                    filedTitleMandatory={false}
                    fieldName={'gmeterId'}
                    placeHolder={'Enter G_UAN'}
                    fieldValue={fieldName}
                    disabled={true}
                    handleOnChange={handleOnChange}
                    formik={formik}
                  />
                </Col>
              )}

              {formik.getFieldMeta('gcontractStartDate').value && (
                <Col sm={4} md={4} ref={rowRef}>
                  <label htmlFor={'gcontractStartDate'} className='d-flex align-items-center mb-2'>
                    <span className='fs-6 fw-semibold lh-23px'> G_Contract Start Date</span>
                  </label>
                  <DatePicker
                    className='form-control form-control-lg form-control-solid mb-2 '
                    id={'startDate'}
                    minDate={new Date()}
                    selected={
                      formik.values.gcontractStartDate
                        ? new Date(formik.values.gcontractStartDate)
                        : null
                    }
                    onChange={(val) => formik.setFieldValue('gcontractStartDate', val)}
                    dateFormat='MM-dd-yyyy'
                    autoComplete='off'
                    placeholderText='MM-DD-YYYY'
                    disabled={true}
                  />
                </Col>
              )}
            </Row>
          </Col>

          {featureFlags?.getClientFeatureFlags?.isBillImagesRequired &&
            data?.billImageUrl.length > 0 && (
              <Col md={6} className='pr-0' id='customer-info-bill'>
                {/* <Viewer
                      urls={data?.billImageUrl}
                      previewSettings={GLOBAL_CONSTANTS.previewSettings}
                      className={`w-500px m-auto h-350px`}
                    /> */}
                <Viewer
                  urls={data?.billImageUrl}
                  files={[]}
                  previewSettings={{
                    isFluidWidth: false,
                    width: 540,
                    height: 350,
                  }}
                  isDeletable={false}
                />
              </Col>
            )}
        </Row>
        <div className="d-flex gap-6">
          {data?.customerEnrollments[0]?.notes?.map((val: any, i: number) => (
            <div
              key={i}
              className="d-flex flex-column"
            >
              <label
                style={{ color: '#5E6278' }}
                className="form-check-label fw-semibold fs-5 mb-2"
              >
                {`E_Note ${i + 1}`}
              </label>
              <input
                className="form-control"
                type="text"
                value={val.noteValue}
                disabled
                placeholder="Note value"
              />
            </div>
          ))}
        </div>
        <div className="d-flex gap-6 mt-2">
          {data?.customerEnrollments[1]?.notes?.map((val: any, i: number) => (
            <div
              key={i}
              className="d-flex flex-column"
            >
              <label
                style={{ color: '#5E6278' }}
                className="form-check-label fw-semibold fs-5 mb-2"
              >
                {`G_Note ${i + 1}`}
              </label>
              <input
                className="form-control"
                type="text"
                value={val.noteValue}
                disabled
                placeholder="Note value"
              />
            </div>
          ))}
        </div>
        <div className='row mt-10'>
          <div className='col-6'>
            <label className='fs-4 fw-bold lh-1'>
              <span className='text-gray-800'>Service Address</span>
            </label>
          </div>
        </div>

        {/* Service Address Details */}
        {serviceAddressDetails.map((rowItem: any, index: number) => {
          return (
            <Row className='d-flex mt-5 no-gutters noPadding' style={{ marginBottom: '1.25rem' }} key={index}>
              {rowItem.map((colItem: any, idx: number) => {
                return colItem.fieldName === 'serviceState' ? (
                  <Col sm={4} md={4} className='pb-5 form-dropdown' key={idx}>
                    <label className='d-flex align-items-center mb-2'>
                      <span className='fs-6 fw-semibold lh-23px'>{colItem.fieldTitle}</span>
                    </label>
                    <Dropdown
                      fieldName={colItem.fieldName}
                      optionList={colItem.fieldName === 'serviceState' ? stateOptionList : []}
                      handleSelectedItem={handleSelectedItem}
                      fieldDisabled={colItem.disabled ? true : !btnShow}
                      formik={formik}
                    />
                  </Col>
                ) : (
                  <Col
                    sm={
                      colItem.fieldName === 'serviceAddressLine1' ||
                        colItem.fieldName === 'serviceAddressLine2'
                        ? 12
                        : 4
                    }
                    md={
                      colItem.fieldName === 'serviceAddressLine1' ||
                        colItem.fieldName === 'serviceAddressLine2'
                        ? 12
                        : 4
                    }
                    className={
                      colItem.fieldName === 'serviceAddressLine1' ||
                        colItem.fieldName === 'serviceAddressLine2' ||
                        idx === 2
                        ? 'pb-5 pr-0'
                        : 'pb-5'
                    }
                  >
                    <TextField
                      fieldTitle={colItem.fieldTitle}
                      filedTitleMandatory={colItem.filedTitleMandatory}
                      fieldName={colItem.fieldName}
                      placeHolder={colItem.placeHolder}
                      maxLength={colItem.maxLength}
                      disabled={colItem.disabled ? true : !btnShow}
                      handleOnChange={handleOnChange}
                      formik={formik}
                    />
                  </Col>
                )
              })}
            </Row>
          )
        })}

        <div className='form-check form-check-sm form-check-custom form-check-solid'>
          <input
            className='form-check-input'
            type='checkbox'
            checked={sameAddress}
            onClick={(e) => handleCheckBox(e)}
            disabled={!btnShow}
          />
          <label
            htmlFor=''
            style={{ color: '#5E6278' }}
            className='form-check-label fw-semibold fs-5'
          >
            Billing address is the same as the service address
          </label>
        </div>

        {/* Billing Address Title*/}
        <div className='row mt-10'>
          <div className='col-6'>
            <label className='fs-4 fw-bold lh-1'>
              <span className='text-gray-800'>Billing Address</span>
            </label>
          </div>
        </div>

        {/* Billing Address Details */}
        {billingAddressDetails.map((rowItem: any, index: number) => {
          return (
            <Row
              className='d-flex mt-5 no-gutters noPadding'
              style={{ marginBottom: '1.25rem' }}
              key={index}
            >
              {rowItem.map((colItem: any, idx: number) => {
                return colItem.fieldName === 'billingState' ? (
                  <Col sm={4} md={4} className='pb-5 form-dropdown' key={idx}>
                    <label className='d-flex align-items-center mb-2'>
                      <span className='fs-6 fw-semibold lh-23px'>{colItem.fieldTitle}</span>
                    </label>
                    <Dropdown
                      fieldName={colItem.fieldName}
                      optionList={colItem.fieldName === 'billingState' ? stateOptionList : []}
                      handleSelectedItem={handleSelectedItem}
                      fieldDisabled={colItem.disabled ? true : !btnShow ? true : sameAddress}
                      formik={formik}
                    />
                  </Col>
                ) : (
                  <Col
                    sm={
                      colItem.fieldName === 'billingAddressLine1' ||
                        colItem.fieldName === 'billingAddressLine2'
                        ? 12
                        : 4
                    }
                    md={
                      colItem.fieldName === 'billingAddressLine1' ||
                        colItem.fieldName === 'billingAddressLine2'
                        ? 12
                        : 4
                    }
                    className={
                      colItem.fieldName === 'billingAddressLine1' ||
                        colItem.fieldName === 'billingAddressLine2' ||
                        idx === 2
                        ? 'pb-5 pr-0'
                        : 'pb-5'
                    }
                    key={idx}
                  >
                    <TextField
                      fieldTitle={colItem.fieldTitle}
                      filedTitleMandatory={colItem.filedTitleMandatory}
                      fieldName={colItem.fieldName}
                      placeHolder={colItem.placeHolder}
                      maxLength={colItem.maxLength}
                      disabled={colItem.disabled ? true : !btnShow ? true : sameAddress}
                      handleOnChange={handleOnChange}
                      formik={formik}
                    />
                  </Col>
                )
              })}
            </Row>
          )
        })}
        {showMapAndDistance &&
          (featureFlags?.getClientFeatureFlags?.enableEmailDocumentVerification ||
            featureFlags?.getClientFeatureFlags?.enableSmsDocumentVerification) && (
            <Row>
              {data?.customerEnrollments[0]?.customerLatitude &&
                data?.customerEnrollments[0]?.customerLongitude &&
                !isNaN(Number(data.customerEnrollments[0]?.customerLatitude)) && (
                  <Col lg={6}>
                    <div className='row my-3'>
                      <div className='col-6'>
                        <label className='fs-4 fw-bold lh-1'>
                          <span className='text-gray-800'>Customer Location</span>
                        </label>
                      </div>
                    </div>

                    <GMap
                      lat={Number(data.customerEnrollments[0]?.customerLatitude)}
                      lng={Number(data?.customerEnrollments[0]?.customerLongitude)}
                      markerText={'C'}
                    />
                  </Col>
                )}
              {agentData?.agentLatitude && agentData?.agentLongitude && (
                <Col lg={6}>
                  <div className='row my-3'>
                    <div className='col-6'>
                      <label className='fs-4 fw-bold lh-1'>
                        <span className='text-gray-800'>Agent Location</span>
                      </label>
                    </div>
                  </div>

                  <GMap
                    lat={Number(agentData?.agentLatitude)}
                    lng={Number(agentData?.agentLongitude)}
                    markerText={'A'}
                  />
                </Col>
              )}
            </Row>
          )}

        {showMapAndDistance && data?.agentToCustomerDistance !== null && (
          <div className='d-flex mt-5'>
            <label className='fs-4 fw-bold lh-1'>
              <span className='text-gray-800 me-2'>Distance between agent and customer device</span>
            </label>
            <p className='fs-5 mb-0'> : {data?.agentToCustomerDistance?.toFixed(2)} ft</p>
          </div>
        )}
        {showMapAndDistance && data?.agentToServiceBillAddressDistance !== null && (
          <div className='d-flex mt-5'>
            <label className='fs-4 fw-bold lh-1'>
              <span className='text-gray-800 me-2'>
                Distance between customer service address and agent
              </span>
            </label>
            <p className='fs-5 mb-0'> : {data?.agentToServiceBillAddressDistance?.toFixed(2)} ft</p>
          </div>
        )}

        <div className='d-flex flex-stack pt-5'>
          <div>
            <button
              type='reset'
              onClick={() => handleDiscard()}
              className={`btn btn-light me-3 ${btnShow ? null : 'd-none'}`}
            >
              Discard
            </button>

            <button
              type='submit'
              onClick={() => formik.handleSubmit()}
              className={`btn btn-lg btn-primary ${btnShow ? null : 'd-none'}`}
            >
              Update
            </button>
          </div>
        </div>
        {showAudit && (
          <div className='accordion mt-5' id='kt_accordion_1'>
            <div className='accordion-item'>
              <h2 className='accordion-header' id='kt_accordion_1_header_1'>
                <button
                  className='accordion-button fs-4 fw-bold collapsed'
                  type='button'
                  data-bs-toggle='collapse'
                  data-bs-target='#kt_accordion_1_body_1'
                  aria-expanded='false'
                  aria-controls='kt_accordion_1_body_1'
                >
                  Audit Trail
                </button>
              </h2>
              <div
                id='kt_accordion_1_body_1'
                className='accordion-collapse collapse'
                aria-labelledby='kt_accordion_1_header_1'
                data-bs-parent='#kt_accordion_1'
              >
                <div className='accordion-body'>
                  <CustomerAudit
                    tpvId={tpvId}
                    auditData={auditData}
                    auditDataLoading={auditDataLoading}
                    getTPVAuditList={getTPVAuditList}
                    filterOptions={filterOptions}
                    setFilterOptions={setFilterOptions}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default CustomerInfo
